import { useState, type KeyboardEvent } from 'react';
import styles from './NoteComposer.module.css';

export interface NoteComposerProps {
  readonly maxLength: number;
  readonly disabled: boolean;
  onSubmit: (text: string) => void;
}

export function NoteComposer({ maxLength, disabled, onSubmit }: NoteComposerProps) {
  const [draft, setDraft] = useState('');

  function commit() {
    const trimmed = draft.trim();
    if (trimmed.length === 0) return;
    onSubmit(trimmed);
    setDraft('');
  }

  function handleKeyDown(event: KeyboardEvent<HTMLTextAreaElement>) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      commit();
    }
  }

  return (
    <div className={styles.composer}>
      <textarea
        className={styles.textarea}
        value={draft}
        rows={2}
        maxLength={maxLength}
        placeholder="Add a note…"
        disabled={disabled}
        onChange={(event) => setDraft(event.target.value)}
        onKeyDown={handleKeyDown}
      />
      <div className={styles.footer}>
        <span className={styles.budget}>
          {draft.length}/{maxLength}
        </span>
        <button type="button" className={styles.add} disabled={disabled || draft.trim().length === 0} onClick={commit}>
          Add
        </button>
      </div>
    </div>
  );
}
